module.exports = __webpack_public_path__ + "img/4.ee365b90.jpg";